import { render, staticRenderFns } from "./ResidentGroupTable.vue?vue&type=template&id=668f8ee2&scoped=true&lang=pug"
import script from "./ResidentGroupTable.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupTable.vue?vue&type=script&lang=ts"
import style0 from "./ResidentGroupTable.vue?vue&type=style&index=0&id=668f8ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f8ee2",
  null
  
)

export default component.exports